export const auth = {
  login(returnTo = '/#/dashboard') {
    window.location.href = `/api/auth/login?returnTo=${encodeURIComponent(returnTo)}`;
  },
  async me() {
    const response = await fetch('/api/auth/me', {
      credentials: 'include',
      signal: globalThis.AbortSignal?.timeout ? AbortSignal.timeout(5000) : undefined
    });
    if (!response.ok) return null;
    return (await response.json()).user;
  },
  async logout() {
    await fetch('/api/auth/logout', { method: 'POST', credentials: 'include' });
    localStorage.removeItem('h150_auth_user');
  }
};
